import React from 'react';
import PropTypes from 'prop-types';
import SearchInput from 'chameleon/ui-stack/ui/basic/search-input';

const SearchToolsLite = (props) => {
  const {
    inputPlaceholder,
    inputRef,
    inputContainerClassName,
    inputClassName,
    isSearchTextEmpty,
    onInputKeyPress,
    text,
    setText,
    onClearText,
    searchTipsButton,
    children,
  } = props;
  return (
    <div className="flex w-full gap-x-4">
      <div className="flex flex-1">
        <SearchInput
          inputPlaceholder={inputPlaceholder}
          className={inputContainerClassName}
          inputClassName={inputClassName}
          text={text}
          setText={setText}
          isSearchTextEmpty={isSearchTextEmpty}
          onInputKeyPress={onInputKeyPress}
          onClearText={onClearText}
          inputRef={inputRef}
        />
        {children}
      </div>
      {searchTipsButton}
    </div>
  );
};

SearchToolsLite.propTypes = {
  inputPlaceholder: PropTypes.string.isRequired,
  //@todo revisit - why it's func or object
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  inputContainerClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  isSearchTextEmpty: PropTypes.bool.isRequired,
  onInputKeyPress: PropTypes.func.isRequired,
  text: PropTypes.string,
  setText: PropTypes.func.isRequired,
  onClearText: PropTypes.func.isRequired,
  searchTipsButton: PropTypes.element.isRequired,
};

SearchToolsLite.defaultProps = {
  inputContainerClassName: '',
  inputClassName: 'rounded-24.8',
  inputRef: () => {},
  text: '',
};

export default SearchToolsLite;
